<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="vendas"
            app_submodulo="relatorio-analitico"
            app_tela="relatorio-ven-check-in-out"
            :objectList="checkList"
            :objectListAll="checkListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            :tooltipLabelSearch="
            $t('msg-campo-busca-n', {
                    n: `${$t('codigo')}, ${$t('rsocial')} do ${$t('cliente')} e ${$t(
                        'nome'
                    )} (${$t('cliente')}, ${$t('colaborador')} e ${$t('empresa')})`,
                })
            "
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:table-column="{ props, field }">
                <div v-if="field.key === 'mapa'">
                    <div
                        @click="
                            isCoordinatesValid(props.row) ? showCheckInOutLocation(props.row) : null
                        "
                    >
                        <b-icon
                            :class="{ 'is-clickable': isCoordinatesValid(props.row) }"
                            pack="fas"
                            icon="map-marker-alt"
                            :type="isCoordinatesValid(props.row) ? 'is-primary' : 'is-gray'"
                        />
                    </div>
                </div>
                <div v-else-if="field.key === 'cliente_distancia'">
                    <span
                        :class="{
                            'is-text-color-success':
                                props.row.isCheckInNoCliente === 1 && isCoordinatesValid(props.row),
                            'is-text-color-danger':
                                props.row.isCheckInNoCliente === 0 && isCoordinatesValid(props.row),
                        }"
                    >
                        {{ props.row[field.key] }}
                    </span>
                </div>
                <div v-else>
                    {{ isNull(props.row[field.key]) ? '---' : props.row[field.key] }}
                </div>
            </template>

            <template v-slot:top-filter>
                <vss-select
                    title="empresa"
                    ref="empresaSelect"
                    class="smaller"
                    :value="empresaSelected"
                    :options="empresaList"
                    :height="40"
                    :loading="empresaLoading"
                    @search="carregarEmpresas"
                    @input="updateEmpresa"
                    label="rsocial"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>

            <template v-slot:lateral-filter>
                <FiltroRotaCheckInOut
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>

        <lateral-content :title="$t('mapa')" v-model="showMap" compact header>
            <div class="is-flex is-flex-hbetween">
                <div v-for="(marker, index) in mapMarkers" class="p-3" :key="index">
                    <div>
                        <b-checkbox v-model="marker.visible" type="is-primary">
                            {{ $t(marker.title) }}
                        </b-checkbox>
                    </div>
                </div>
            </div>

            <div class="map-container pl-2 pr-2 pb-2">
                <gmap-map
                    ref="mapRef"
                    :zoom="zoom"
                    :center="center"
                    style="width: 100%; height: 100%"
                    :options="mapOptions"
                >
                    <gmap-marker
                        v-for="(marker, index) in mapMarkers"
                        :position="marker.position"
                        :visible="marker.visible"
                        :clickable="false"
                        :key="`marker${index}${marker.position.lat}${marker.position.lng}`"
                    >
                        <gmap-info-window :options="infoWindowOptions" :opened="marker.visible">
                            <div>
                                {{ $t(marker.title) }}
                            </div>
                        </gmap-info-window>
                    </gmap-marker>

                    <gmap-info-window
                        v-for="(midpoint, index) in midpointsBetweenPoints"
                        :options="infoWindowOptions"
                        :position="midpoint.position"
                        :opened="true"
                        :key="`midpoint${index}${midpoint.position.lat}${midpoint.position.lng}`"
                    >
                        <div class="distance-info-window">{{ Math.floor(midpoint.distance) }}m</div>
                    </gmap-info-window>

                    <gmap-polyline :path="pathBetweenClienteCheckInOut" />
                </gmap-map>
            </div>
        </lateral-content>
    </div>
</template>

<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import FiltroRotaCheckInOut from '@/components/vendas/relatorios/relatorio-ven-check-in-out/RelatorioVenCheckInOutListFiltro.vue';

export default {
    components: {
        RelatorioAnaliticoComponentList,
        FiltroRotaCheckInOut,
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            checkList: [],
            checkListAll: [],
            filtros: {
                idEmpresaList: [],
                idColaboradorList: [],
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                idClienteList: [],
                checkInNoCliente: 2,
                clienteHasGeolocalizacao: 2,
                checkInHasGeolocalizacao: 2,
            },

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'idcheck',
                orderDirection: 'desc',
                queryFilter: '.*',
            },

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            isLoading: false,
            loadedFiels: false,

            isEmpty: true,
            filtersReset: false,

            showMap: false,
            zoom: 16,
            mapOptions: { gestureHandling: 'cooperative' },
            infoWindowOptions: {
                headerDisabled: true,
            },
            center: {
                lat: 0,
                lng: 0,
            },
            mapMarkers: [],
            pathBetweenClienteCheckInOut: [],
            midpointsBetweenPoints: [],
            isDataStarted: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
        mapMarkers: {
            deep: true,
            handler: function () {
                const visibleMarkers = this.mapMarkers
                    .filter((marker) => marker.visible)
                    .map((marker) => ({ ...marker.position }));

                this.pathBetweenClienteCheckInOut = visibleMarkers;

                this.midpointsBetweenPoints = this.setDistanceInfoWindow(visibleMarkers);
            },
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        onSearch(value) {
            this.pagination.queryFilter = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if (!getAll) this.checkListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`ven/relatorio/check-in-out/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => ({
                        ...obj,
                        checkindatahora: obj.checkindatahora ? this.$moment(obj.checkindatahora).format('L LT') : obj.checkindatahora,
                        checkoutdatahora: obj.checkoutdatahora ? this.$moment(obj.checkoutdatahora).format('L LT') : obj.checkoutdatahora,
                        precisaocheckin: this.getDecimal(obj.precisaocheckin, 4),
                        velocidadecheckin: this.getDecimal(obj.velocidadecheckin, 4),
                        precisaocheckout: this.getDecimal(obj.precisaocheckout, 4),
                        velocidadecheckout: this.getDecimal(obj.velocidadecheckout, 4),
                        cliente_distancia: Math.floor(obj.cliente_distancia),
                        mapa: '---',
                    }));
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.checkListAll = mappedContent;
                    } else {
                        this.checkList = mappedContent;
                    }
                })
                .catch(() => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    if (!getAll) this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },

        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.$axios
                .get(`/vendas/empresa/list.json?param=${search}`)
                .then((response) => {
                    this.empresaList = response.data.content.map((e) => {
                        return {
                            id: e.idempresa,
                            rsocial: e.rsocial,
                        };
                    });
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idEmpresaList =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(search = '') {
            this.colaboradorLoading = true;

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${search}`, empresa)
                .then((response) => {
                    this.colaboradorList = response.data.content;
                })
                .catch(() => {
                    this.empresaList = [];
                })
                .finally(() => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idColaboradorList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';

            this.filtros.idEmpresaList = [];
            this.empresaSelected = [];

            this.filtros.idColaboradorList = [];
            this.colaboradorSelected = [];

            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataFinal = new Date();

            this.filtros.checkInNoCliente = 2;
            this.filtros.clienteHasGeolocalizacao = 2;
            this.filtros.checkInHasGeolocalizacao = 2;

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },

        isCoordinatesValid(checkInOut) {
            const isLpsCoordinatesValid =
                checkInOut.cliente_latitude != 0 && checkInOut.cliente_longitude != 0;

            const isCheckInCoordinatesValid =
                checkInOut.latitudecheckin != 0 && checkInOut.longitudecheckin != 0;

            return isLpsCoordinatesValid && isCheckInCoordinatesValid;
        },
        showCheckInOutLocation(checkInOut) {
            const clientePosition = {
                lat: checkInOut.cliente_latitude,
                lng: checkInOut.cliente_longitude,
            };

            this.zoom = 16;

            this.center = clientePosition;

            const checkInPosition = {
                lat: checkInOut.latitudecheckin,
                lng: checkInOut.longitudecheckin,
            };

            const checkOutPosition = {
                lat: checkInOut.latitudecheckout,
                lng: checkInOut.longitudecheckout,
            };

            this.mapMarkers = [
                {
                    title: 'cliente',
                    position: clientePosition,
                    visible: true,
                },
                {
                    title: 'check-in',
                    position: checkInPosition,
                    visible: true,
                },
                {
                    title: 'check-out',
                    position: checkOutPosition,
                    visible: true,
                },
            ];

            this.showMap = true;
        },
        calculateMidpoint(pointA, pointB) {
            const latARad = this.degreesToRadians(pointA.lat);
            const lonARad = this.degreesToRadians(pointA.lng);
            const latBRad = this.degreesToRadians(pointB.lat);
            const lonBRad = this.degreesToRadians(pointB.lng);

            const coordsA = this.sphericalToCartesian(latARad, lonARad);
            const coordsB = this.sphericalToCartesian(latBRad, lonBRad);

            const midpointCartesian = this.averageCartesianCoords(coordsA, coordsB);

            const midpoint = this.cartesianToSpherical(midpointCartesian);

            return midpoint;
        },
        sphericalToCartesian(lat, lon) {
            return {
                x: Math.cos(lat) * Math.cos(lon),
                y: Math.cos(lat) * Math.sin(lon),
                z: Math.sin(lat),
            };
        },
        averageCartesianCoords(coordsA, coordsB) {
            return {
                x: (coordsA.x + coordsB.x) / 2,
                y: (coordsA.y + coordsB.y) / 2,
                z: (coordsA.z + coordsB.z) / 2,
            };
        },
        cartesianToSpherical(cartesian) {
            const lon = Math.atan2(cartesian.y, cartesian.x);
            const hyp = Math.sqrt(cartesian.x * cartesian.x + cartesian.y * cartesian.y);
            const lat = Math.atan2(cartesian.z, hyp);

            return {
                lat: this.radiansToDegrees(lat),
                lng: this.radiansToDegrees(lon),
            };
        },
        degreesToRadians(degrees) {
            return degrees * (Math.PI / 180);
        },
        radiansToDegrees(radians) {
            return radians * (180 / Math.PI);
        },
        calculateDistance(point1, point2) {
            const EARTH_RADIUS_KM = 6371;

            const lat1Rad = this.degreesToRadians(point1.lat);
            const lon1Rad = this.degreesToRadians(point1.lng);
            const lat2Rad = this.degreesToRadians(point2.lat);
            const lon2Rad = this.degreesToRadians(point2.lng);

            const deltaLatRad = lat2Rad - lat1Rad;
            const deltaLonRad = lon2Rad - lon1Rad;

            const a =
                Math.sin(deltaLatRad / 2) ** 2 +
                Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(deltaLonRad / 2) ** 2;

            const centralAngleRad = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            const distanceKm = EARTH_RADIUS_KM * centralAngleRad;
            const distanceMeters = distanceKm * 1000;

            return distanceMeters;
        },
        setDistanceInfoWindow(mapMarkers) {
            const distances = [];

            for (let i = 0; i < mapMarkers.length - 1; i++) {
                const startPosition = mapMarkers[i];
                const endPosition = mapMarkers[i + 1];

                distances.push({
                    distance: this.calculateDistance(startPosition, endPosition),
                    position: this.calculateMidpoint(startPosition, endPosition),
                });
            }

            return distances;
        },
    },
};
</script>

<style lang="scss" scoped>
.gm-style .gm-style-iw-t::after {
    background: none;
    box-shadow: none;
}

div ::v-deep .gm-style-iw-d {
    scrollbar-width: none;
    padding-bottom: 17px;
    padding-right: 12px;
}

.custom-distance-info-window::after {
    display: none;
}

.map-container {
    height: 90%;
}

.relatorio-analitico {
    height: 100%;
}
</style>
